import { SvgIcon, type SvgIconProps } from '@ltvco/refresh-lib/theme';

export const SocialTwitterIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M23.995 12.0004C23.995 18.0612 19.5038 23.0717 13.6692 23.8848C13.1237 23.9605 12.5655 24 11.999 24C11.345 24 10.7028 23.9479 10.0774 23.847C4.36558 22.9271 0.00292969 17.9729 0.00292969 12.0004C0.00292969 5.37295 5.37429 0 11.9998 0C18.6253 0 23.9967 5.37295 23.9967 12.0004H23.995Z"
      fill="#1C1C1B"
    />
    <path
      d="M4.86845 5.29222L10.4012 12.6916L4.83398 18.7078H6.08731L10.9619 13.4408L14.9 18.7078H19.1643L13.3206 10.8922L18.5028 5.29222H17.2495L12.7607 10.143L9.1336 5.29222H4.86928H4.86845ZM6.71102 6.21546H8.66959L17.3201 17.7845H15.3615L6.71102 6.21546Z"
      fill="white"
    />
  </SvgIcon>
);
